import { useSettings } from '@backpackjs/storefront';
import { Image } from 'theme-ui';

import { Svg, Link } from '@snippets';

import { themed } from './Menu.theme';

export const Logo = themed(({ theme }) => {
  const settings = useSettings();
  const { header } = { ...settings };
  const { logo } = { ...header };

  const logoSrc = logo?.image?.src;
  const logoAlt = logo?.alt || 'Brumate logo';

  return (
    <Link href="/" aria-label="Go to Brumate homepage">
      {logoSrc ? (
        <Image src={logoSrc} alt={logoAlt} sx={theme.logo} />
      ) : (
        <Svg
          role="presentation"
          viewBox="0 0 1588 375"
          src="/svgs/brumate-logo.svg#brumate-logo"
          alt={logoAlt}
          sx={theme.logo}
        />
      )}
    </Link>
  );
});